import React from 'react'
import { useTranslation } from 'react-i18next'
import SectionComponent from '../../../../components/utils/SectionComponent'
import "./productPerformanceList.scss"

function ProductPerformanceList() {
  const {t} = useTranslation()

  return (
    <div className='container-product-performance-list'>
      <div className="texts-product-performance-list">
        <SectionComponent title={t("retail.product_performance_list.product_performance.title")} text={t("retail.product_performance_list.product_performance.section_text")} />
        <SectionComponent title={t("retail.product_performance_list.inventary_control.title")} text={t("retail.product_performance_list.inventary_control.section_text")} />

        <SectionComponent title={t("retail.product_performance_list.profit_up.title")} text={t("retail.product_performance_list.profit_up.section_text")} />
        <SectionComponent title={t("retail.product_performance_list.orders.title")} text={t("retail.product_performance_list.orders.section_text")} />
        <SectionComponent title={t("retail.product_performance_list.analysis.title")} text={t("retail.product_performance_list.analysis.section_text")} />
        <SectionComponent title={t("retail.product_performance_list.customer.title")} text={t("retail.product_performance_list.customer.section_text")} />
      </div>
    </div>
  )
}

export default ProductPerformanceList